import { getFirebaseApp } from './firebaseApp.js';

/**
 * Lazily-initialised Firebase Realtime Database handle.
 *
 * Firebase is a large dependency and group mode is opt-in, so the SDK is only
 * downloaded the first time someone opens a group session. Returns `null` when
 * Firebase is not configured, which is the signal for the group feature to fall
 * back to its cross-tab localStorage adapter.
 *
 * @returns {Promise<import('firebase/database').Database | null>}
 */
export async function getRealtimeDb() {
  if (cached !== undefined) return cached;

  const app = await getFirebaseApp();
  if (!app) {
    cached = null;
    return cached;
  }

  try {
    const { getDatabase } = await import('firebase/database');
    cached = getDatabase(app);
  } catch (error) {
    console.warn('[crave] Firebase unavailable, using local group sync:', error.message);
    cached = null;
  }

  return cached;
}

/** @type {import('firebase/database').Database | null | undefined} */
let cached;
